export const Role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
export default Role;
